import React, { useState } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { getItemTypeColor, MAP_COLORS } from "../utils/colors";
import { MapFilter } from "../types";
import { IconFilter } from "./icons/IconFilter";
import { ListingItemDot } from "./ListingItemDot";

const filterLabels: Record<MapFilter, string> = {
  all: "All",
  person: "Members",
  event: "Events",
  product: "Products",
  project: "Projects",
  service: "Services",
  creative: "Creative",
  organization: "Organizations",
  article: "Articles",
  course: "Courses",
};

interface MapFilterProps {
  selectedFilter: MapFilter;
  onFilterChange: (filter: MapFilter) => void;
}

export const MapFilterControls: React.FC<MapFilterProps> = ({
  selectedFilter,
  onFilterChange,
}) => {
  const [filterOpen, setFilterOpen] = useState(false);

  const allFilters = Object.keys(filterLabels) as MapFilter[];

  return (
    <div
      style={{
        position: "absolute",
        top: "20px",
        right: "20px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <button
        style={{
          background: "white",
          border: "1px solid #e2e8f0",
          borderRadius: "4px",
          padding: "6px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
        }}
        onClick={() => {
          setFilterOpen(!filterOpen);
        }}
      >
        <IconFilter />
        {/* COLORED DOT */}
        {selectedFilter !== "all" && (
          <ListingItemDot type={selectedFilter} marginLeft={5} />
        )}
      </button>

      {filterOpen && (
        <div
          style={{
            background: "white",
            borderRadius: "0px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
          }}
        >
          <div style={{ padding: "12px" }}>
            {allFilters.map((filter) => (
              <label
                key={filter}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: filter === "service" ? "0" : "8px",
                  cursor: "pointer",
                  fontSize: "13px",
                  color: "#2d3748",
                }}
              >
                <input
                  type="radio"
                  name="mapFilter"
                  value={filter}
                  checked={selectedFilter === filter}
                  onChange={(e) => {
                    const val = e.target.value as MapFilter;
                    onFilterChange(val);
                    setFilterOpen(false);
                  }}
                  style={{
                    margin: "0",
                    width: "14px",
                    height: "14px",
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {/* COLORED DOT */}
                  {filter !== "all" && <ListingItemDot type={filter} />}

                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
